import { PaymentMethodOption } from 'api/checkout';

export default {
  'account:main-page:title': 'Hallo {firstName}',

  'account:navigation:orders': 'Bestellingen',
  'account:navigation:subscriptions': 'Bespaarabonnement',
  'account:navigation:refer-friend': 'Vrienden werven',
  'account:navigation:last-order': 'Laatste bestelling opnieuw bestellen',
  'account:navigation:credits': 'Tegoed',
  'account:navigation:addresses': 'Adressen',
  'account:navigation:logout': 'Uitloggen',
  'account:navigation:bonus-program': 'Bonusprogramma',

  'account:bonus-program:title': 'Bonusprogramma',

  'account:bonus-program:sub-header': 'Jouw actuele puntenstand',
  'account:bonus-program:expire-information': '{amount} vervalt op {date}',
  'account:bonus-program:points-amount':
    '{amount, plural, =0 {# punten} one {# punt} other {# punten}}',
  'account:bonus-program:quick-links': 'Snelkoppelingen',
  'account:bonus-program:redeem-points': 'Punten omzetten in tegoed',
  'account:bonus-program:redeem-points-cta': '{pointAmount} punten <span>➡</span>    {conversion}',
  'account:bonus-program:redeem-points-fairvalue-cta':
    'Fairvalue {pointAmount} punten <span>➡</span> {conversion}',

  'account:bonus-program:donate:cta-info': '{amount} voor het Berlijnse dierenasiel',
  'account:bonus-program:donate:donate': 'doneren',

  'account:bonus-program:product-redemption': 'Premie voor punten',
  'account:bonus-program:product-redemption-description':
    'Jouw premie wordt met je volgende bestelling verstuurd.',
  'account:bonus-program:mov-check-message-head': 'Oeps! ',
  'account:bonus-program:mov-check-message':
    'Jouw winkelwagen moet minstens {mov} bedragen, zodat je verder kunt gaan naar de kassa.',
  'account:bonus-program:not-enough-bonus-point': 'Je hebt niet genoeg bonuspunten op je account.',
  'account:bonus-program:gift-not-enough-point': '{pointAmount} punten nodig',
  'account:bonus-program:bp-redemption-item-succesfully-add-to-cart':
    'Jouw artikel is succesvol aan de winkelwagen toegevoegd.',

  'account:bonus-program:my-points:redeeem-title': 'Mijn punten inwisselen',
  'account:bonus-program:my-points': 'TRANSACTIEGESCHIEDENIS',
  'account:bonus-program:my-points-description':
    'Met slechts één klik wissel je je verzamelde punten in voor daadwerkelijk <Link>tegoed</Link>, dat bij je volgende bestelling automatisch wordt toegepast.',
  'account:bonus-program:action:redeem-success': 'Jouw punten zijn succesvol omgezet in tegoed.',

  'account:bonus-program:points': 'Punt',
  'account:bonus-program:coins': '{transaction} bonuspunten',
  'account:bonus-program:action': 'Actie',
  'account:bonus-program:acquire-date': 'Ontvangen op',
  'account:bonus-program:expire-date': 'Geldig tot',
  'account:bonus-program:redeem': 'Inwisseling',
  'account:bonus-program:refund': 'Annulering',
  'account:bonus-program:expired': 'Puntenverval',
  'account:bonus-program:reward-order': 'Bestelling',
  'account:bonus-program:reward-bonus': 'ExtraPunten',

  'account:bonus-program:info-bar:text':
    '<strong>Ons bonusprogramma loopt af</strong><li>Vanaf <strong>31-12-2025</strong> spaar je <strong>geen bonuspunten</strong> meer.</li><li><strong>De 12 maanden geldigheid</strong> blijft bestaan.</li><li>Punten kunnen tot het einde van hun geldigheid, <strong>uiterlijk tot 15-01-2027</strong> worden ingewisseld.</li>',

  'account:orders:title': 'Bestellingen',
  'account:orders:title-single': 'Bestelling',
  'account:orders:reorder': 'Nabestellen',
  'account:orders:order-again': 'Opnieuw bestellen',
  'account:orders:invoice': 'Factuur',
  'account:orders:download:invoice_sale': 'Factuur downloaden',
  'account:orders:download:invoice_refund': 'Correctie downloaden',

  'account:orders:invoice-download-not-ready':
    'We moeten je levering nog verwerken voordat je de factuur kunt downloaden.',
  'account:orders:tracking-invoice-available-after-shipping':
    'Factuur en zendingtracering zijn na de verzending beschikbaar',
  'account:orders:details': 'Details',
  'account:orders:billing-same-as-shipping': 'komt overeen met leveringsadres',
  'account:orders:order-number': 'Bestelnr.',
  'account:orders:date': 'Besteldatum',
  'account:orders:price': 'Prijs',
  'account:orders:point': '{points} punten',
  'account:orders:payment-status': 'Betaalstatus',
  'account:orders:payment-pending': 'In afwachting',
  'account:orders:payment-authorized': 'Geautoriseerd',
  'account:orders:payment-paid': 'Betaald',
  'account:orders:payment-partially_paid': 'Gedeeltelijk betaald',
  'account:orders:payment-partially_refunded': 'Gedeeltelijk terugbetaald',
  'account:orders:payment-refunded': 'Terugbetaald',
  'account:orders:payment-voided': 'Ongeldig',
  'account:orders:fulfillment-status': 'Leverstatus',
  'account:orders:fulfillment-fulfilled': 'Verzonden',
  'account:orders:fulfillment-null': 'In afwachting',
  'account:orders:fulfillment-restocked': 'Teruggestuurd',
  'account:orders:fulfillment-partial': 'Gedeeltelijk verzonden',
  'account:orders:fulfillment-track-delivery': 'Volgen',

  'account:refer-friend:title':
    'Delen, besparen en cadeau geven: {amount} voor jou - {amountFriend} voor je dierbaren',
  'account:refer-friend:personal-link':
    '<strong> Jouw uitnodigingslink is gekopieerd </strong> <br></br>Verstuur de link nu naar je vrienden en verzeker je van je {amount}-tegoed!',
  'account:refer-friend:email-send':
    '<strong> Jouw uitnodiging is verstuurd </strong> <br></br>Je ontvangt je tegoed automatisch zodra je vriend(in) een bestelling heeft geplaatst.',
  'account:refer-friend:give-email-addresss': 'E-mail van je vriend(in):',
  'account:refer-friend:give-email-addresss-subtitle':
    'Voer het e-mailadres alleen in met toestemming van je vriend(in).',
  'account:refer-friend:invitation-button': 'Nu uitnodiging versturen',
  'account:refer-friend:invitation-sent': 'Klaar!',
  'account:refer-friend:share-link': 'Of deel je code via:',
  'account:refer-friend:info-intro': 'Zodat alles soepel verloopt, hier de belangrijkste info:',
  'account:refer-friend:info-use-link':
    '<strong>Gebruik je link:</strong> Alleen via je persoonlijke aanbevelingslink kunnen we je vrienden als geworven herkennen.',
  'account:refer-friend:info-min-order':
    '<strong>Minimale bestelwaarde:</strong> Je vrienden moeten minstens 40 € uitgeven – dat is makkelijk met ons assortiment!',
  'account:refer-friend:info-no-late-claims':
    '<strong>Geen nameldingen:</strong> Aanmeldingen achteraf per e-mail of telefoon zijn helaas niet mogelijk.',
  'account:refer-friend:info-cancellations':
    '<strong>Annuleringen:</strong> Wordt de bestelling geannuleerd of niet betaald, dan is er helaas geen tegoed.',
  'account:refer-friend:info-no-coupon-combo':
    '<strong>Geen combinatie van cadeaubonnen:</strong> Bij de bestelling van je vrienden kunnen helaas geen extra cadeaubonnen worden gebruikt.',
  'account:refer-friend:email-required': 'Gelieve in te vullen!',
  'account:refer-friend:email-invalid': 'Voer een geldig e-mailadres in!',

  'account:credits:title': 'Tegoed',
  'account:credits:date': 'Datum',
  'account:credits:amount': 'Bedrag',
  'account:credits:reason': 'Reden',
  'account:credits:balance': 'Pets Deli tegoed: ',
  'account:credits:info-title': 'Je hebt nog geen transacties.',
  'account:credits:info-text':
    "Als je tegoed hebt bij Pets Deli, worden de transacties hier weergegeven. Tegoed ontvang je bijv. via Pets Deli acties of creditnota's.",
  'account:credits:reason-Order Application': 'Aankoop',
  'account:credits:reason-Referal': 'Vrienden werven',
  'account:credits:reason-Refund': 'Terugbetaling',
  'account:credits:reason-Customer Support': 'Customer Support',
  'account:credits:reason-Bonusprogramm': 'Bonusprogramma',

  'account:order:title': 'Bestelling {orderName}',

  'account:addresses:title': 'Adressen',
  'account:addresses:edit:title': 'Adres wijzigen',
  'account:addresses:create:title': 'Adres toevoegen',
  'account:addresses:create-success': 'Adres succesvol toegevoegd',
  'account:addresses:update-success': 'Adres succesvol aangemaakt',
  'account:addresses:delete-success': 'Adres succesvol verwijderd',
  'account:addresses:set-default-success': 'Adres succesvol ingesteld',
  'account:addresses:add': 'Adres toevoegen',
  'account:addresses:phone': 'Tel.: {phone}',
  'account:addresses:change': 'Wijzigen',
  'account:addresses:delete': 'Verwijderen',
  'account:addresses:set-default': 'Als standaardadres instellen',
  'account:addresses:is-default': 'Als standaard ingesteld',
  'account:addresses:edit-form:submit': 'Opslaan',
  'account:addresses:create-form:submit': 'Opslaan',

  'account:subscriptions:title': 'Bespaarabonnement',
  'account:subscriptions:details': 'Details',
  'account:subscriptions:active': 'Actief',
  'account:subscriptions:paused': 'Gepauzeerd',
  'account:subscriptions:cancelled': 'Beëindigd',
  'account:subscriptions:title-title': 'Levering <span>{shortId}</span>',
  'account:subscriptions:items-amount':
    '{amount, number} {amount, plural, one {product} other {producten}}',
  'account:subscriptions:next-delivery': 'Volgende verzending',
  'account:subscriptions:interval': 'Interval',
  'account:subscriptions:price': 'Warenwaarde',
  'account:subscriptions:price:info': '(zonder eventuele kortingen en verzendkosten)',
  'account:subscriptions:interval-14': 'elke 2 weken',
  'account:subscriptions:interval-28': 'elke 4 weken',
  'account:subscriptions:interval-42': 'elke 6 weken',
  'account:subscriptions:interval-56': 'elke 8 weken',

  'account:subscription:title': 'Levering #{shortId}',
  'account:subscription:actions:title': 'Bespaarabonnement aanpassen',
  'account:subscription:actions:next-shipping-date': 'Volgende verzending verschuiven',
  'account:subscription:actions:shipping-address': 'Leveringsadres wijzigen',
  'account:subscription:actions:billing-address': 'Factuuradres wijzigen',
  'account:subscription:actions:interval': 'Leveringsinterval wijzigen',
  'account:subscription:products:out-of-stock': 'Momenteel niet verkrijgbaar',
  'account:subscription:products:product-slider:title': 'Product aan de levering toevoegen',
  'account:subscription:products:product-slider:subscription:button':
    'Abonneren & <span>besparen</span>',
  'account:subscription:products:product-slider:one-off:button': 'Eenmalig bestellen',
  'account:subscription:products:product-slider:subscription:modal:cta-button': 'Nu abonneren',
  'account:subscription:products:product-slider:one-off:modal:cta-button': 'Eenmalig bestellen',
  'account:subscription:products:product-slider:subscription:text':
    'Onze snacks in het abonnement en altijd <strong>10% besparen</strong>!',
  'account:subscription:products:product-slider:one-off:text':
    'Het product wordt met de abonnementsbestelling geleverd.',

  'account:subscription:state-change:reason:not_home':
    'Ik kan de leveringen de komende tijd niet ontvangen (bijv. vakantie)',
  'account:subscription:state-change:reason:still_enough':
    'Ik heb nog voldoende producten op voorraad',
  'account:subscription:state-change:reason:try_other':
    'Ik wil de komende tijd andere producten proberen',
  'account:subscription:state-change:reason:not_happy': 'Ik ben ontevreden met het huidige aanbod',
  'account:subscription:state-change:reason:by_mistake': 'Per ongeluk aangemeld',
  'account:subscription:state-change:reason:OOS': 'Het product is altijd uitverkocht',
  'account:subscription:state-change:reason:expensive': 'Het product is te duur',
  'account:subscription:state-change:reason:unhappy_web': 'De website was moeilijk te bedienen',
  'account:subscription:state-change:reason:too_much': 'Ik heb nog genoeg voeding thuis',
  'account:subscription:state-change:reason:unhappy_CuHa':
    'Ik kan jullie klantenservice / jullie voedingsadviseur(s) niet bereiken',
  'account:subscription:state-change:reason:adjust': 'Ik wil mijn abonnement aanpassen',
  'account:subscription:state-change:reason:aging':
    'Mijn huisdier heeft andere voeding nodig vanwege de leeftijd',
  'account:subscription:state-change:reason:health':
    'Mijn huisdier heeft andere voeding nodig om gezondheidsredenen',
  'account:subscription:state-change:reason:food_type':
    'Mijn huisdier heeft een ander soort voeding nodig',
  'account:subscription:state-change:reason:acceptancy': 'Mijn huisdier lust de voeding niet meer',
  'account:subscription:state-change:reason:other_supplier':
    'Ik bestel de voeding nu ergens anders',
  'account:subscription:state-change:reason:delivery': 'Slechte ervaring met de levering',
  'account:subscription:state-change:reason:other': 'Andere reden',
  'account:subscription:state-change:reason:unhappy_web:text-placeholder':
    'Wat heeft je precies gestoord?',
  'account:subscription:state-change:reason:other_supplier:text-placeholder':
    'Wil je ons vertellen waar je de voeding nu koopt?',
  'account:subscription:state-change:reason:other:text-placeholder': 'Vertel ons gerust welke...',

  'account:subscription:state-change:modal:reason:by_mistake:title':
    'Wil je echt afzien van je voordelen?',
  'account:subscription:state-change:modal:reason:too_much:title':
    'Wist je dat je je abonnement kunt aanpassen/pauzeren?',
  'account:subscription:state-change:modal:reason:acceptancy:title':
    'Wil je huisdier iets nieuws proberen?',
  'account:subscription:state-change:modal:reason:aging:title':
    'Wij bieden voeding voor elke leeftijdsgroep aan!',
  'account:subscription:state-change:modal:reason:health:title':
    'Pets Deli biedt voeding voor speciale behoeften aan!',
  'account:subscription:state-change:modal:reason:health:sub-title':
    'Bijvoorbeeld bij allergieën, gewichts- en acceptatieproblemen. Pets Deli ondersteunt je bij de gezondheid van je dier!',
  'account:subscription:state-change:modal:reason:food_type:title': 'Wij staan voor je klaar!',
  'account:subscription:state-change:modal:reason:food_type:sub-title':
    'Of je nu droogvoer, natvoer, BARF of een mengvorm wilt voeren - bij Pets Deli vind je afgestemde producten.',

  'account:subscription:state-change:modal:info': 'Leer meer dankzij ons gratis voedingsadvies:',

  'account:subscription:state-change:modal:button:confirm': 'OPZEGGEN',
  'account:subscription:state-change:modal:button:pause': 'Pauzeren',
  'account:subscription:state-change:modal:button:adjust-date': 'Datum aanpassen',

  'account:subscription:state-change:modal:list:item-1':
    '<span>10% korting</span> bij elke bestelling',
  'account:subscription:state-change:modal:list:item-2': 'Altijd voldoende voeding thuis',
  'account:subscription:state-change:modal:list:item-3': 'Altijd flexibel aanpassen of pauzeren',

  'account:subscription:state-change:modal:consultation:title':
    'Laat je <span>gratis</span> door voedingsexperts adviseren',
  'account:subscription:state-change:modal:consultation:phone': 'Bel direct ({phone})',
  'account:subscription:state-change:modal:consultation:appointment':
    'Maak <span>hier</span> een afspraak',

  'account:subscription:state-change:cancel:navigation-title': 'Abonnement opzeggen',
  'account:subscription:state-change:cancel:title': 'Jammer dat je weggaat',
  'account:subscription:state-change:cancel:description':
    'We werken er voortdurend aan om ons aanbod nog gebruiksvriendelijker te maken. Vertel ons daarom de reden voor het beëindigen van je regelmatige levering:',
  'account:subscription:state-change:pause:navigation-title': 'Levering pauzeren of verschuiven',
  'account:subscription:state-change:pause:delivery:title':
    'Verschuif je levering naar je gewenste periode',
  'account:subscription:state-change:pause:delivery:description':
    'Heb je nog genoeg producten thuis of ga je op welverdiende vakantie? Verschuif dan je volgende levering gewoon tot maximaal acht weken naar een later tijdstip!',
  'account:subscription:state-change:pause:delivery:datepicker-text':
    'Verzending van de volgende levering op....',
  'account:subscription:state-change:pause:open-pause-view-cta': 'Levering pauzeren',
  'account:subscription:state-change:pause:delivery-cta': 'Verzending verschuiven',
  'account:subscription:state-change:pause:reason:title': 'Prima! Nog één stap',
  'account:subscription:state-change:pause:reason:description':
    'We werken er voortdurend aan om ons aanbod nog gebruiksvriendelijker te maken. Vertel ons daarom de reden voor het pauzeren van je regelmatige levering:',
  'account:subscription:state-change:pause:reason:submit': 'Nu pauzeren',
  'account:subscription:state-change:success-message': 'Leveringsstatus succesvol gewijzigd',
  'account:subscriptions:info-button': 'Voordelen van het bespaarabonnement',
  'account:subscriptions:info-text':
    'Met een regelmatige voedingslevering kun je elke maand echt geld besparen.',
  'account:subscriptions:info-title': 'Je hebt geen actief bespaarabonnement',

  'account:subscription:summary:interval': 'Leveringsinterval',
  'account:subscription:summary:next-shipping': 'Volgende verzending',
  'account:subscription:summary:billing-address-equal-shipping-address':
    'komt overeen met leveringsadres',
  'account:subscription:summary:shipping-method': 'Verzendmethode',
  'account:subscription:summary:status': 'Status',
  'account:subscription:summary:payment-method:credit-card': 'Creditcard',

  'account:subscription:items-quantity-change:success-message': 'Aantal succesvol gewijzigd',
  'account:subscription:item-recover:success-message': 'Het product is succesvol toegevoegd',
  'account:subscription:next-shipping:title': 'Verzending verschuiven',
  'account:subscription:next-shipping:current-value': 'Huidige verzenddatum',
  'account:subscription:next-shipping:new-value': 'Nieuwe verzenddatum',
  'account:subscription:next-shipping:save-button': 'Verzending verschuiven',
  'account:subscription:next-shipping:success-message': 'Levering succesvol verschoven',
  'account:subscription:interval:title': 'Leveringsinterval wijzigen',
  'account:subscription:interval:current-interval': 'Huidig interval',
  'account:subscription:interval:new-interval': 'Nieuw interval',
  'account:subscription:interval:save': 'Leveringsinterval wijzigen',
  'account:subscription:interval:success-message': 'Leveringsinterval succesvol gewijzigd',
  'account:subscription:shipping-address:title': 'Leveringsadres wijzigen',
  'account:subscription:billing-address:title': 'Factuuradres wijzigen',
  'account:subscription:shipping-address:success-message': 'Leveringsadres succesvol gewijzigd',
  'account:subscription:addresses:new-address': 'Nieuw adres toevoegen',
  'account:subscription:addresses:select-cta': 'Naar dit adres verzenden',

  'account:subscription:add-item-cta': '+ nog een product toevoegen',

  'account:subscription:status-action:cancel': 'Opzeggen',
  'account:subscription:status-action:pause': 'Pauzeren',
  'account:subscription:status-action:procede': 'Voortzetten',

  'account:subscription:remove-item': 'Product verwijderen',
  'account:subscription:add-item-again': 'Opnieuw toevoegen',
  'account:subscription:active-products': 'Actieve producten',
  'account:subscription:deleted-products': 'Verwijderde producten',
  'account:subscription:modal:delete-item:title':
    'Weet je zeker dat je dit product uit je abonnement wilt verwijderen?',
  'account:subscription:modal:delete-item:subtitle':
    ' Dit product wordt uit het abonnement verwijderd. Het verwijderde product zie je boven in het overzicht.',
  'account:subscription:modal:delete-item:cancel': 'Het product behouden',
  'account:subscription:modal:delete-item:confirm': 'Ja, het product verwijderen',

  'account:subscription:modal:question':
    'Jouw levering is momenteel niet actief. Wil je deze levering weer ontvangen?',
  'account:subscription:modal:confirmation': 'Ja, levering activeren',
  'account:subscription:modal:rejection': 'Nee',

  'account:reset:page-title': 'Nieuw wachtwoord instellen',

  'account:subscription:one-time:more-details': 'Meer details',
  'account:subscription:in-process': 'In behandeling',
  'account:subscription:run-immediately': 'Direct uitvoeren',
  'account:subscription:execute-now-confirmation:title':
    'Weet je zeker dat je je bespaarabonnement nu wilt uitvoeren?',
  'account:subscription:execute-now-confirmation:message': 'Prijs en verwachte leverdatum',
  'account:subscription:execute-now-confirmation:yes': 'Bevestigen',
  'account:subscription:execute-now-confirmation:no': 'Annuleren',
  'account:subscription:deliver-ondemand:confirmation':
    'Jouw verzending wordt direct gestart.{br}Mag het nog wat meer zijn?',
  'account:subscription:deliver-ondemand:oos:confirmation':
    'Sommige producten zijn niet beschikbaar',
  'account:subscription:deliver-ondemand:oos:confirmation:all-items-oos':
    'Helaas zijn alle producten van je bespaarabonnement uitverkocht',
  'account:subscription:deliver-ondemand:oos:confirmation:message':
    'Wil je je bestelling zonder deze producten ontvangen?',
  'account:subscription:deliver-ondemand:oos:confirmation:message-all-items-oos':
    'Wil je een nieuwe bestelling aanmaken?',
  'account:subscription:deliver-ondemand:oos:confirmation:button:all-items-oos':
    'Andere producten ontdekken',
  'account:subscription:deliver-ondemand:confirmation-speed-delivery': 'Bevestigen',
  'account:subscription:deliver-ondemand:confirmation-contain-oos': 'Verder',
  'account:subscription:deliver-ondemand:confirmation-added-item': 'Toegevoegd',
  'account:subscription:speed-delivery-subtitle':
    '*Het product wordt met de abonnementsbestelling geleverd.',
  'account:subscription:deliver-ondemand:customise-subscription': 'Bespaarabonnement aanpassen',
  'account:subscription:info-bar:text':
    '<span>Of blader door producten en voeg ze direct toe aan het abonnement. Meer in de <a>FAQ</a></span>',

  'account:subscription:payment-reauthorisation:header':
    'Autoriseer een betaalmethode voor je abonnement',
  'account:subscription:payment-reauthorisation:body':
    'We zijn van betaalprovider gewisseld.{br}Autoriseer een van de volgende betaalmethoden om in de toekomst je regelmatige leveringen te waarborgen.',
  'account:subscription:payment-reauthorisation:saved-payment-method':
    'Jouw huidige betaalgegevens:',
  'account:subscription:payment-reauthorisation:new-payment-method':
    'Kies een betaalmethode voor je abonnement:',
  'account:subscription:payment-reauthorisation:button:confirm': 'Bevestigen',
  [`account:subscription:payment-reauthorisation:option:${PaymentMethodOption.CreditCard}`]:
    'Kaart',
  [`account:subscription:payment-reauthorisation:option:${PaymentMethodOption.PayPal}`]: 'PayPal',
  'account:subscription:payment-reauthorisation:current-payment-method':
    'De huidige betaalmethode gebruiken',
  'account:subscription:mov-modal:your request failed': 'Jouw aanvraag is mislukt',
  'account:subscription:mov-modal:make sure your subtotal is':
    'Zorg ervoor dat het subtotaal {br} van je aankoop boven {mov} ligt.',
  'account:subscription:mov-modal:why-mov': 'Waarom {mov} minimale bestelwaarde?',
  'account:subscription:mov-modal:mov-explanation':
    'Elk pakket en elke verzending veroorzaakt CO2-uitstoot. Door erop te letten dat pakketten een bepaalde grootte hebben, verminderen we automatisch verpakkingsafval en uitstoot en leveren we zo een kleine bijdrage aan het milieu. {br} {br} Hartelijk dank voor je medewerking!',
  'account:subscription:mov-modal:request help': 'Hulp van de klantenservice aanvragen',
  'account:subscription:one-off-item-info':
    'Dit product is niet voor je gereserveerd. Om er zeker van te zijn dat je het ontvangt, kies je de optie <strong>Direct uitvoeren</strong>.',
  'account:upsell-product:cta': 'Meebestellen',
  'account:upsell-product:cta-item-added': 'Toegevoegd',

  'account:pet-profile:title:with-name': '{name}s beste keuze',
  'account:pet-profile:title:with-multiple-pets': 'De beste keuze voor {names}',
  'account:pet-profile:title:with-multiple-pets-others': ' & Co.',
  'account:pet-profile:title:without-name': 'Al de juiste voeding?',
  'account:pet-profile:subtitle:with-name': 'Bekijk {name}s persoonlijke productselectie!',
  'account:pet-profile:subtitle:without-name':
    'Kom erachter – met onze gepersonaliseerde aanbeveling!',
  'account:pet-profile:subtitle:with-multiple-pets': 'Bekijk hun persoonlijke productselectie!',
  'account:refer-friend:info-new-customers-only':
    '<strong>Alleen voor nieuwe klanten:</strong> Je vriend of vriendin moet voor het eerst bij Pets Deli bestellen.',
  'account:refer-friend:info-different-household':
    '<strong>Ander huishouden:</strong> Je vriend of vriendin mag niet tot hetzelfde huishouden behoren als jij.',
  'account:subscription:execute-now-confirmation:info-card:total-label': 'Totaalbedrag incl. btw',
  'account:subscription:execute-now-confirmation:info-card:delivery-date-label':
    'Verwachte leverdatum',
  'account:subscription:execute-now-confirmation:info-card:delivery-date-pending': 'Wordt berekend',
  'account:subscription:deliver-ondemand:oos:badge': 'Uitverkocht',
  'account:subscription:deliver-ondemand:success-toast':
    'Je bestelling wordt vandaag nog verwerkt!',
  'account:subscription:price-summary:active-until': 'Actief tot {activeUntil}',
  'account:subscription:price-summary:shipping-price': '* €',
  'account:subscription:price-summary:shipping-info':
    '*<b>Verzendkosten</b> worden bij elke bestelling opnieuw berekend. Gratis levering vanaf 60 €.',
  'account:subscription:price-summary:credit-info':
    '<b>Tegoed</b> wordt pas verrekend bij het aanmaken van de bestelling.',
};
